import { AlertScore, VerticalLabelItem } from '../../components';

export default {
  defaultComponent: {
    itemName: 'default',
    gsPick: ['itemLabel', 'itemName'],
    component: VerticalLabelItem
  },
  customComponents: [
    {
      itemName: 'alertScore',
      gsPick: ['itemLabel', 'itemName'],
      addtionalPick: ['alertLevel', 'alertLevelLabel', 'alertLevelColor'],
      component: AlertScore
    }
  ]
};
